export default __webpack_public_path__ + "static/media/success-blue.63fbed0d.svg";